export const DEFAULT_TIMESLOT_FORMAT = 'HH:mm';
export const DEFAULT_TIMESLOT_SHOW_FORMAT = 'h:mm A';
export const DEFAULT_TIMESLOTS = Array(24)
  .fill(null)
  .map((n, i) => [`${i}`, `${i + 1}`]);
